module.exports = __webpack_public_path__ + "img/main-graphics-title.835927d4.png";